export default __webpack_public_path__ + "static/summer_containers40-a6d766d180934aad7d4c0030f6cb0a56.webp";